import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import {
    Button,
    TextField,
    FormControl,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Menu,
    Table,
    Grid,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    MenuItem,
    List,
    ListItem,
    Typography,
    Container,
    Chip,
    IconButton,
} from "@material-ui/core";
import { Add, Remove, Clear } from "@material-ui/icons";
import LockIcon from '@material-ui/icons/Lock';
import Tooltip from '@material-ui/core/Tooltip';
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { ocrTypes, navPath, navSearch } from "../../constants";
import { useSnackbar } from "notistack";
import { HV_THEME, HVHeader, HVInput, Card, HVButton, HVSelect, StatusPill, Icons, ContentLoader, ScreenEmpty, Spinner } from "../shared/DesignSystem";

const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(grey[900]),
        backgroundColor: grey[900],
        "&:hover": {
            backgroundColor: grey[900],
        },
        marginLeft: 30,
        marginTop: 20,
        height: 50,
    },
}))(Button);

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        marginBottom: 30,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: "transform 0.15s ease-in-out",
        "&:hover": { transform: "scale3d(1.02, 1.02, 1)" },
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginTop: 12,
    },
    cards: {
        marginTop: 50,
        marginLeft: 25
    },
});
function ProjectHome(props) {
    const classes = useStyles({
        listItem: {
            padding: '8px 16px', // Adjust padding as needed
        },
    });
    const { enqueueSnackbar } = useSnackbar();
    const [projects, setProjects] = useState([]);
    const [tags, setTags] = useState({
        Untagged: {
            selected: false,
            count: 0,
        },
    });
    const [name, setName] = useState("");
    const [translate, setTranslate] = useState(false);
    const [sorting, setSorting] = useState(false);
    const [open, setOpen] = useState(false);
    const [openLayoutNext, setOpenLayoutNext] = useState(false);
    const [openLexNext, setOpenLexNext] = useState(false);
    const [version, setVersion] = useState("3");
    const [promptSelect, setPromptSelect] = useState("prompt1");
    const [lexModel, setLexModel] = useState("openai:gpt-3.5-turbo");
    const [lexMultiplier, setLexMultiplier] = useState(1);
    const [projectType, setProjectType] = useState("extraction");
    const [ocrType, setOcrType] = useState("google");
    const [type, setType] = useState("card");
    const [loading, setLoading] = useState(true);
    const [creating, setCreating] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [newTagName, setNewTagName] = useState("");
    const [selectedProjectsForTagging, setSelectedProjectsForTagging] = useState([]);
    const [search, setSearch] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);
    const [openNewTagDialog, setOpenNewTagDialog] = useState(false);


    const filteredProjects = projects.filter(project =>
        (project.name ?? "").toLowerCase().includes(search.toLowerCase()) || (project._id ?? "").toLowerCase().includes(search.toLowerCase())
    );

    const handleProjectSelectForTagging = (e, id) => {
        if (e.target.checked) {
            setSelectedProjectsForTagging([...selectedProjectsForTagging, id]);
        } else {
            setSelectedProjectsForTagging(selectedProjectsForTagging.filter((item) => item !== id));
        }
    };

    // Handle change page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Handle change rows per page
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    // eslint-disable-next-line no-template-curly-in-string
    const [prompt, setPrompt] = useState("Extract information as a JSON:\nExtract: fieldName ()\n${ocr}");

    const [inputFields, setInputFields] = useState([
        { id: uuidv4(), field: "", validationType: "", description: "", hallucinationCheck: true },
    ]);
    const [validationInputFields, setValidationInputFields] = useState([
        { id: uuidv4(), field: "", validationType: "" },
    ]);


    const updatePromptValue = (fieldValues, promptStyle = promptSelect) => {
        let result;
        if (promptStyle === "prompt1") {
            result = fieldValues.map(({ field, description }) => `${field} (${description})`).join(', ');
        } else if (promptStyle === "prompt2") {
            result = fieldValues.map(({ field }) => `${field}`).join(', ');
        }
        if (result) {
            setPrompt(`Extract information as a JSON:\nExtract: ${result}\n\${ocr}`);
        }
    }

    const handleChangeInput = (id, event) => {
        const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
                i[event.target.name] = event.target.value;
            }
            return i;
        });
        setInputFields(newInputFields);
    };

    const handleValidationChangeInput = (id, event) => {
        const newInputFields = validationInputFields.map((i) => {
            if (id === i.id) {
                i[event.target.name] = event.target.value;
            }
            return i;
        });
        setValidationInputFields(newInputFields);
    };

    const handleChangeLexInput = (id, event) => {
        const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
                i[event.target.name] = event.target.value;
            }
            return i;
        });
        setInputFields(newInputFields);
        updatePromptValue(newInputFields);
    };

    const handleHallucinationCheck = (id, e) => {
        const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
                i[e.target.name] = e.target.checked;
            }
            return i;
        });
        setInputFields(newInputFields);
    }

    const handleChangeLexPrompt = (event) => {
        setPrompt(event.target.value);
    };

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            { id: uuidv4(), field: "", validationType: "", description: "", hallucinationCheck: true },
        ]);
    };

    const handleAddValidationFields = () => {
        setValidationInputFields([
            ...validationInputFields,
            { id: uuidv4(), field: "", validationType: "" },
        ]);
    };

    const handleRemoveFields = (id) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setInputFields(values);
        updatePromptValue(values);
    };

    const handleRemoveValidationFields = (id) => {
        const values = [...validationInputFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setValidationInputFields(values);
    };

    const processProjectData = (projects) => {
        if (!projects) return;
        if (projects.length === 0) return;

        const TAGS = {
            Untagged: {
                selected: false,
                count: 0,
            },
        };

        for (let i = 0; i < projects.length; i++) {
            const project = projects[i];
            if (!project.tags) continue;
            for (let j = 0; j < project.tags.length; j++) {
                if (TAGS[project.tags[j]]) {
                    TAGS[project.tags[j]].count += 1;
                } else {
                    TAGS[project.tags[j]] = {
                        selected: false,
                        count: 1,
                    }
                }
            }
            if (project.tags.length === 0) {
                TAGS["Untagged"].count += 1;
            }
        }
        setTags(TAGS);
    }

    const getProjects = () => {
        setLoading(true);
        axios
            .get("/api/projects/list?query=deployment")
            .then((data) => {
                const list = Array.isArray(data.data) ? data.data : [];
                processProjectData(list);
                setProjects(list);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                enqueueSnackbar('Failed to load projects', { variant: 'error' });
                setLoading(false);
            });
    };

    useEffect(() => {
        getProjects();
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleBack = () => {
        setOpen(true);
        setOpenLayoutNext(false);
        setOpenLexNext(false);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenLayoutNext(false);
        setOpenLexNext(false);
    };

    const handleNext = () => {
        if (!name.trim()) {
            enqueueSnackbar('Project name is required', { variant: 'error' });
            return;
        }
        setOpen(false);
        if (version === 'lex') {
            setOpenLexNext(true);
        } else {
            setOpenLayoutNext(true);
        }
    };

    const handleBenchmarkClick = (id, name, projectType) => {
        props.history.push({
            pathname: `/project/benchmarks/${id}`,
            search: navSearch(),
            state: {
                id: id,
                name: name,
                docType: projectType,
                benchmarkCategory: 'project',
            },
        });
    };

    const createProject = () => {
        setCreating(true);
        const data = {
            project: {
                name,
                inputFields: inputFields,
                validationInputFields,
                projectType,
                ocrType,
                type,
                status: version === 'lex' ? "model_generated" : "created",
                translate,
                sorting,
                version,
                prompt,
                lexModel,
                lexMultiplier
            },
        };
        axios
            .post("/api/projects/create", data)
            .then((res) => {
                enqueueSnackbar("Project created successfully", { variant: "success" });
                setProjects([]);
                setName("");
                setInputFields([{ id: uuidv4(), field: "", validationType: "", description: "", hallucinationCheck: true }]);
                setValidationInputFields([{ id: uuidv4(), field: "", validationType: "" }]);
                setOpenLayoutNext(false);
                setOpenLexNext(false);
                getProjects();
            })
            .catch((e) => {
                enqueueSnackbar(e.response.data, { variant: "error" });
            })
            .finally(() => setCreating(false));
    };

    const addTagToProjects = (projectIds, tag) => {
        if (projectIds.length === 0) {
            enqueueSnackbar("No projects selected", {
                variant: "error",
            });
            return;
        }
        if (!tag || tag === "") {
            enqueueSnackbar("No tag selected", {
                variant: "error",
            });
            return;
        }
        axios
            .post("/api/projects/addTagToProjects", {
                projectIds,
                tag,
            })
            .then((res) => {
                enqueueSnackbar(res.data, {
                    variant: "success",
                });
                getProjects();
            })
            .catch((e) => {
                enqueueSnackbar(e.response.data, {
                    variant: "error",
                });
            });
    };

    const handleName = (e) => {
        setName(e.target.value);
    };

    const handleTranslate = (e) => {
        setTranslate(e.target.checked)
    }

    const handleSorting = (e) => {
        setSorting(e.target.checked)
    }

    const handleVersion = (e) => {
        setVersion(e.target.value)
    }

    const handleLexModel = (e) => {
        setLexModel(e.target.value)
    }

    const handleLexMultiplier = (e) => {
        setLexMultiplier(e.target.value)
    }

    const handleType = (e) => {
        setType(e.target.value)
    }

    const handleProjectType = (e) => {
        setProjectType(e.target.value);
    };

    const handleOcrType = (e) => {
        setOcrType(e.target.value);
    };

    const handlePromptSelect = (e) => {
        setPromptSelect(e.target.value);
        updatePromptValue(inputFields, e.target.value);
    };

    const handleClick = (projectId) => {
        props.history.push(navPath(`/project/${projectId}`));
    };


    const [statusFilter, setStatusFilter] = React.useState('all');
    const [typeFilter, setTypeFilter] = React.useState('all');
    const [tagFilter, setTagFilter] = React.useState('all');

    const STATUS_TONE = {
        production: { tone: 'ok', label: 'In production' },
        review: { tone: 'warn', label: 'In review' },
        training: { tone: 'info', label: 'Training' },
        draft: { tone: 'neutral', label: 'Draft' },
        failed: { tone: 'danger', label: 'Failed' },
        locked: { tone: 'purple', label: 'Locked' },
        created: { tone: 'neutral', label: 'Created' },
        database_created: { tone: 'neutral', label: 'Created' },
        model_generation_failed: { tone: 'danger', label: 'Generation Failed' }
    };
    const TAG_PALETTE = {
        'Production': { bg: '#e7f5ed', fg: '#0f5d2a', bd: '#b7dfca' },
        'Testing':    { bg: '#e6efff', fg: '#1a3a8a', bd: '#b3c9f7' },
        'In Review':  { bg: '#fdf1dc', fg: '#7a4a07', bd: '#f5d68a' },
    };
    const tagStyle = (tag, active = false) => active
        ? { background: '#000', color: '#fff', border: '1px solid #000' }
        : { background: TAG_PALETTE[tag]?.bg || '#fff', color: TAG_PALETTE[tag]?.fg || HV_THEME.ink, border: '1px solid ' + (TAG_PALETTE[tag]?.bd || '#e0e0e0') };
    const role = {
        name: 'Admin', initials: 'AD', color: '#e6194b', label: 'Admin',
        can: { create: true }
    };

    const filtered = React.useMemo(() => {
        return projects.filter(p => {
            if (search && !(p.name?.toLowerCase().includes(search.toLowerCase()) || p._id.includes(search))) return false;
            if (tagFilter !== 'all') {
                if (tagFilter === 'Untagged' && (!p.tags || p.tags.length === 0)) return true;
                if (tagFilter !== 'Untagged' && (!p.tags || !p.tags.includes(tagFilter))) return false;
            }
            if (typeFilter !== 'all' && p.type !== typeFilter) return false;
            if (statusFilter === 'locked' && !p.isLocked) return false;
            if (statusFilter === 'production' && p.status !== 'production') return false;
            return true;
        });
    }, [search, tagFilter, typeFilter, statusFilter, projects]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / rowsPerPage));
    const pageItems = filtered.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

    const dlabelStyle = { display: 'block', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: HV_THEME.mute, marginBottom: 6 };
    const dinputStyle = { width: '100%', height: 38, border: '1px solid #d4d4d4', borderRadius: 2, padding: '0 12px', fontFamily: 'inherit', fontSize: 13, color: HV_THEME.ink, outline: 0, boxSizing: 'border-box' };

    return (
        <div data-screen-label="01 Projects" style={{ background: HV_THEME.bg, minHeight: '100vh', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", color: HV_THEME.ink }}>
            <HVHeader tab="projects" role={role} env="STAGING" onTab={props.onTab} onLogout={props.onLogout} />

            {/* page body */}
            <div style={{ padding: '28px 40px', maxWidth: 1440, margin: '0 auto' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 22 }}>
                    <div>
                        <div style={{ fontSize: 10, letterSpacing: '0.18em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Workspace</div>
                        <h1 style={{ fontSize: 28, fontWeight: 700, margin: '6px 0 4px', letterSpacing: '-0.02em' }}>Projects</h1>
                        <div style={{ fontSize: 13, color: HV_THEME.mute }}>{projects.length} total · {filtered.length} matching filters</div>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <HVButton variant="secondary" icon={<Icons.plus size={14} />} onClick={() => setOpenNewTagDialog(true)}>Tag Projects</HVButton>
                        <HVButton variant="primary" icon={<Icons.plus size={14} />} onClick={handleClickOpen}>New project</HVButton>
                    </div>
                </div>

                <Card pad={0} style={{ padding: '14px 16px', marginBottom: 18, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 320px', minWidth: 280 }}>
                        <HVInput
                            icon={<Icons.search size={16} stroke={HV_THEME.mute} />}
                            placeholder="Search by project name or ID…"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setPage(0); }}
                            suffix={search && <button onClick={() => setSearch('')} style={{ background: 'transparent', border: 0, cursor: 'pointer', color: HV_THEME.mute, padding: 4 }}><Icons.x size={14} /></button>}
                            style={{ borderColor: '#e0e0e0' }}
                        />
                    </div>
                    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                        <select value={typeFilter} onChange={e => { setTypeFilter(e.target.value); setPage(0); }} style={{ appearance: 'none', border: '1px solid #e0e0e0', background: '#fff', padding: '0 30px 0 12px', height: 38, borderRadius: 2, fontFamily: 'inherit', fontSize: 12, fontWeight: 500, color: HV_THEME.ink, cursor: 'pointer' }}>
                            <option value="all">Type: All</option>
                            <option value="card">CARD</option>
                            <option value="doc">DOCUMENT</option>
                            <option value="passport">PASSPORT</option>
                        </select>
                        <Icons.chevDown size={14} stroke={HV_THEME.mute} style={{ position: 'absolute', right: 10, top: 12, pointerEvents: 'none' }} />
                    </div>
                    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                        <select value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(0); }} style={{ appearance: 'none', border: '1px solid #e0e0e0', background: '#fff', padding: '0 30px 0 12px', height: 38, borderRadius: 2, fontFamily: 'inherit', fontSize: 12, fontWeight: 500, color: HV_THEME.ink, cursor: 'pointer' }}>
                            <option value="all">Status: All</option>
                            <option value="locked">Locked</option>
                            <option value="production">In production</option>
                        </select>
                        <Icons.chevDown size={14} stroke={HV_THEME.mute} style={{ position: 'absolute', right: 10, top: 12, pointerEvents: 'none' }} />
                    </div>
                    <div style={{ flex: 1 }} />
                </Card>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 11, color: HV_THEME.mute, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', marginRight: 4 }}>Tags</span>
                    <button onClick={() => { setTagFilter('all'); setPage(0); }} style={{ background: tagFilter === 'all' ? '#000' : '#fff', color: tagFilter === 'all' ? '#fff' : HV_THEME.ink, border: '1px solid ' + (tagFilter === 'all' ? '#000' : '#e0e0e0'), borderRadius: 99, padding: '5px 12px', fontSize: 12, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' }}>
                        All <span style={{ opacity: 0.55, marginLeft: 4 }}>{projects.length}</span>
                    </button>
                    {Object.keys(tags).map(t => {
                        const ts = tagStyle(t, tagFilter === t);
                        return (
                            <button key={t} onClick={() => { setTagFilter(t); setPage(0); }} style={{ ...ts, borderRadius: 99, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                                {t} <span style={{ opacity: 0.55, marginLeft: 4 }}>{tags[t].count}</span>
                            </button>
                        );
                    })}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
                    {loading && <div style={{ gridColumn: '1 / -1' }}><ContentLoader title="Loading projects…" subtitle="Fetching your projects" size="md" /></div>}
                    {!loading && pageItems.length === 0 && <div style={{ gridColumn: '1 / -1' }}><Card pad={0}><div style={{ padding: '60px 20px', textAlign: 'center', color: HV_THEME.mute }}><div style={{ width: 56, height: 56, borderRadius: 99, background: '#f4f4f4', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}><Icons.search size={24} /></div><div style={{ fontSize: 16, fontWeight: 600, color: HV_THEME.ink, marginBottom: 4 }}>{(search || tagFilter !== 'all' || typeFilter !== 'all' || statusFilter !== 'all') ? `No projects match "${search}"` : 'No projects'}</div><div style={{ fontSize: 13 }}>{(search || tagFilter !== 'all' || typeFilter !== 'all' || statusFilter !== 'all') ? 'Try a different search term or clear your filters.' : 'Create your first project to get started.'}</div></div></Card></div>}
                    {!loading && pageItems.map(p => {
                        const tone = STATUS_TONE[p.status] || { tone: 'neutral', label: p.status };
                        return (
                            <Card key={p._id} pad={0} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                <div style={{ padding: 16, paddingBottom: 12 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
                                        <div style={{ width: 40, height: 40, borderRadius: 4, background: p.type === 'card' ? '#eef2ff' : '#fef3e8', color: p.type === 'card' ? '#3949ab' : '#9a4500', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
                                            {p.type === 'card' ? <Icons.image size={18} /> : <Icons.doc size={18} />}
                                        </div>
                                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                            {p.isLocked && (
                                                <span title="Locked" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#fdf1dc', color: '#7a4a07', borderRadius: 99, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>
                                                    <Icons.lock size={10} stroke="#7a4a07" sw={2.5} />LOCKED
                                                </span>
                                            )}
                                            <StatusPill tone={tone.tone} size="sm">{tone.label}</StatusPill>
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4, lineHeight: 1.3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={p.name}>{p.name}</div>
                                    <div style={{ fontSize: 11, color: HV_THEME.mute, fontFamily: "'JetBrains Mono', monospace", marginBottom: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }} onClick={() => {
                                        enqueueSnackbar(`${p._id} copied to clipboard`, { variant: "success", autoHideDuration: 800 });
                                        navigator.clipboard.writeText(p._id);
                                    }}>{p._id} <Icons.copy size={10} /></div>

                                    {/* Tags row */}
                                    {p.tags && p.tags.length > 0 && (
                                        <div style={{ display: 'flex', gap: 4, flexWrap: 'nowrap', overflow: 'hidden', marginBottom: 10, alignItems: 'center' }}>
                                            {p.tags.slice(0, 3).map(tag => {
                                                const tp = TAG_PALETTE[tag] || { bg: '#f1f1f1', fg: '#3a3a3a' };
                                                return (
                                                    <span key={tag} style={{ background: tp.bg, color: tp.fg, borderRadius: 99, padding: '2px 8px', fontSize: 10, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>{tag}</span>
                                                );
                                            })}
                                            {p.tags.length > 3 && (
                                                <span style={{ fontSize: 10, color: HV_THEME.mute, flexShrink: 0 }}>+{p.tags.length - 3}</span>
                                            )}
                                        </div>
                                    )}

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, paddingTop: 10, borderTop: '1px solid #f0f0f0' }}>
                                        <div>
                                            <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>Type</div>
                                            <div style={{ fontSize: 12, fontWeight: 600 }}>{p.type?.toUpperCase()} <span style={{ color: HV_THEME.mute, fontWeight: 400 }}>v{p.version}</span></div>
                                            <div style={{ fontSize: 10, color: HV_THEME.mute, marginTop: 1 }}>{p.ocr}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>Updated</div>
                                            <div style={{ fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{new Date(p.updatedAt).toLocaleDateString()}</div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ borderTop: '1px solid #f0f0f0', padding: '10px 12px', display: 'flex', gap: 6, alignItems: 'center', background: '#fafafa', marginTop: 'auto' }}>
                                    <HVButton size="sm" variant="secondary" style={{ flex: 1 }} onClick={() => handleClick(p._id)}>Open</HVButton>
                                    <HVButton size="sm" variant="ghost" icon={<Icons.beaker size={12} />} onClick={() => handleBenchmarkClick(p._id, p.name, p.type)}>Benchmarks</HVButton>
                                </div>
                            </Card>
                        );
                    })}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 18, padding: '6px 4px' }}>
                    <div style={{ fontSize: 12, color: HV_THEME.mute }}>
                        Showing <strong style={{ color: HV_THEME.ink }}>{filtered.length === 0 ? 0 : page * rowsPerPage + 1}–{Math.min((page + 1) * rowsPerPage, filtered.length)}</strong> of <strong style={{ color: HV_THEME.ink }}>{filtered.length}</strong>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: HV_THEME.mute }}>
                            Rows per page
                            <select value={rowsPerPage} onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }} style={{ border: '1px solid #e0e0e0', background: '#fff', padding: '4px 6px', borderRadius: 2, fontFamily: 'inherit' }}>
                                {[8, 12, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                            </select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <button disabled={page === 0} onClick={() => setPage(0)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page === 0 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page === 0 ? '#bbb' : HV_THEME.ink, cursor: page === 0 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>«</button>
                            <button disabled={page === 0} onClick={() => setPage(page - 1)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page === 0 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page === 0 ? '#bbb' : HV_THEME.ink, cursor: page === 0 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icons.chevL size={13} /></button>
                            <span style={{ fontSize: 12, fontWeight: 600, margin: '0 8px' }}>Page {page + 1} of {totalPages}</span>
                            <button disabled={page >= totalPages - 1} onClick={() => setPage(page + 1)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page >= totalPages - 1 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page >= totalPages - 1 ? '#bbb' : HV_THEME.ink, cursor: page >= totalPages - 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icons.chevR size={13} /></button>
                            <button disabled={page >= totalPages - 1} onClick={() => setPage(totalPages - 1)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page >= totalPages - 1 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page >= totalPages - 1 ? '#bbb' : HV_THEME.ink, cursor: page >= totalPages - 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>»</button>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="create-project" maxWidth="xs" fullWidth>
                <DialogTitle id="create-project" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 700, fontSize: 18, borderBottom: '1px solid #f0f0f0', paddingRight: 48, paddingBottom: 16 }}>
                    Create new project
                    <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", paddingTop: 20 }}>
                    <div style={{ marginBottom: 14 }}>
                        <label style={dlabelStyle}>Project Name <span style={{ color: HV_THEME.danger }}>*</span></label>
                        <input
                            autoFocus
                            value={name}
                            onChange={handleName}
                            placeholder="e.g. Passport Extraction"
                            style={{ ...dinputStyle, borderColor: name.trim() ? '#d4d4d4' : '#e0a0a0' }}
                        />
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={dlabelStyle}>Extraction Type</label>
                        <HVSelect value={projectType} onChange={handleProjectType}>
                            <option value="extraction">Field Extraction</option>
                            <option value="validation">Field Validation</option>
                            <option value="both">Field Extraction and Validation</option>
                        </HVSelect>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={dlabelStyle}>OCR Type</label>
                        <HVSelect value={ocrType} onChange={handleOcrType}>
                            {Object.keys(ocrTypes).map((o) => <option key={o} value={o}>{ocrTypes[o]}</option>)}
                        </HVSelect>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={dlabelStyle}>Version</label>
                        <HVSelect value={version} onChange={handleVersion}>
                            <option value="1">1</option>
                            <option value="3">3</option>
                            <option value="lex">lex</option>
                        </HVSelect>
                    </div>
                    {version === 'lex' && (
                        <div style={{ marginBottom: 14 }}>
                            <label style={dlabelStyle}>Lex Model Name</label>
                            <input value={lexModel} onChange={handleLexModel} style={dinputStyle} />
                        </div>
                    )}
                    {version === 'lex' && (
                        <div style={{ marginBottom: 14 }}>
                            <label style={dlabelStyle}>Lex Multiplier</label>
                            <input value={lexMultiplier} onChange={handleLexMultiplier} style={dinputStyle} />
                        </div>
                    )}
                    <div style={{ marginBottom: 14 }}>
                        <label style={dlabelStyle}>Document Type</label>
                        <HVSelect value={type} onChange={handleType}>
                            <option value="card">Card</option>
                            <option value="doc">Document</option>
                            <option value="passport">Passport</option>
                        </HVSelect>
                    </div>
                    <div style={{ display: 'flex', gap: 20, marginTop: 4 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                            <input type="checkbox" checked={translate} onChange={handleTranslate} style={{ width: 15, height: 15, accentColor: '#000', cursor: 'pointer' }} />
                            Enable Translation
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                            <input type="checkbox" checked={sorting} onChange={handleSorting} style={{ width: 15, height: 15, accentColor: '#000', cursor: 'pointer' }} />
                            Enable Sorting
                        </label>
                    </div>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleClose}>Cancel</HVButton>
                    <HVButton variant="primary" onClick={handleNext} disabled={!name.trim()}>Next</HVButton>
                </DialogActions>
            </Dialog>

            <Dialog open={openLayoutNext} onClose={handleClose} aria-labelledby="create-project-fields" maxWidth="xl">
                <DialogTitle id="create-project-fields" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 700, fontSize: 18, borderBottom: '1px solid #f0f0f0', position: 'relative', paddingRight: 48, paddingBottom: 16 }}>
                    Configure fields
                    <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Container>
                        {projectType !== "validation" ? (
                            <h1>Extraction Fields</h1>
                        ) : (
                            <h1>Validation Fields</h1>
                        )}
                        <form>
                            {inputFields.map((inputField) => (
                                <div key={inputField.id} style={{ marginBottom: 10 }}>
                                    <FormControl style={{ marginTop: 15 }}>
                                        <TextField
                                            name="field"
                                            label="Field Name*"
                                            variant="outlined"
                                            value={inputField.field}
                                            onChange={(event) =>
                                                handleChangeInput(inputField.id, event)
                                            }
                                        />
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    {projectType === "validation" ? (
                                        <FormControl style={{ marginTop: 15 }}>
                                            <TextField
                                                select
                                                name="validationType"
                                                variant="outlined"
                                                value={inputField.validationType}
                                                onChange={(event) =>
                                                    handleChangeInput(inputField.id, event)
                                                }
                                                label="Validation Type"
                                                style={{ width: 250 }}
                                            >
                                                <MenuItem value="strict">Strict</MenuItem>
                                                <MenuItem value="fuzzy">Fuzzy Match</MenuItem>
                                                <MenuItem value="editDistance1">
                                                    Edit Distance 1
                                                </MenuItem>
                                                <MenuItem value="editDistance2">
                                                    Edit Distance 2
                                                </MenuItem>
                                                <MenuItem value="editDistance3">
                                                    Edit Distance 3
                                                </MenuItem>
                                            </TextField>
                                        </FormControl>
                                    ) : (
                                        <span>&nbsp;</span>
                                    )}
                                    <IconButton
                                        disabled={inputFields.length === 1}
                                        onClick={() => handleRemoveFields(inputField.id)}
                                    >
                                        <Remove />
                                    </IconButton>
                                    <IconButton onClick={handleAddFields}>
                                        <Add />
                                    </IconButton>
                                </div>
                            ))}
                        </form>
                        {projectType === "both" ? (
                            <h1>Validation Fields</h1>
                        ) : (
                            <span>&nbsp;</span>
                        )}
                        {projectType === "both" ? (
                            <form>
                                {validationInputFields.map((inputField) => (
                                    <div key={inputField.id} style={{ marginBottom: 10 }}>
                                        <FormControl style={{ marginTop: 15 }}>
                                            <TextField
                                                name="field"
                                                label="Field Name*"
                                                variant="outlined"
                                                value={inputField.field}
                                                onChange={(event) =>
                                                    handleValidationChangeInput(inputField.id, event)
                                                }
                                            />
                                        </FormControl>
                                        <span>&nbsp;</span>
                                        <FormControl style={{ marginLeft: 30, marginTop: 15 }}>
                                            <TextField
                                                select
                                                name="validationType"
                                                variant="outlined"
                                                value={inputField.validationType}
                                                onChange={(event) =>
                                                    handleValidationChangeInput(inputField.id, event)
                                                }
                                                label="Validation Type"
                                                style={{ width: 250 }}
                                            >
                                                <MenuItem value="strict">Strict</MenuItem>
                                                <MenuItem value="fuzzy">Fuzzy Match</MenuItem>
                                                <MenuItem value="editDistance1">
                                                    Edit Distance 1
                                                </MenuItem>
                                                <MenuItem value="editDistance2">
                                                    Edit Distance 2
                                                </MenuItem>
                                                <MenuItem value="editDistance3">
                                                    Edit Distance 3
                                                </MenuItem>
                                            </TextField>
                                        </FormControl>
                                        <IconButton
                                            disabled={validationInputFields.length === 1}
                                            onClick={() =>
                                                handleRemoveValidationFields(inputField.id)
                                            }
                                        >
                                            <Remove />
                                        </IconButton>
                                        <IconButton onClick={handleAddValidationFields}>
                                            <Add />
                                        </IconButton>
                                    </div>
                                ))}
                            </form>
                        ) : (
                            <span>&nbsp;</span>
                        )}
                    </Container>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleClose}>Cancel</HVButton>
                    <HVButton variant="secondary" onClick={handleBack}>Back</HVButton>
                    <HVButton variant="primary" onClick={createProject} disabled={creating} icon={creating ? <Spinner size={14} color="#fff" /> : null}>
                        {creating ? 'Creating…' : 'Create'}
                    </HVButton>
                </DialogActions>
            </Dialog>
            <Dialog open={openLexNext} onClose={handleClose} aria-labelledby="create-project" maxWidth="xl">
                <DialogTitle id="configure-prompt" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 700, fontSize: 18, borderBottom: '1px solid #f0f0f0', position: 'relative', paddingRight: 48, paddingBottom: 16 }}>
                    Configure Prompt
                    <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Container>
                        <TextField
                            select
                            value={promptSelect}
                            onChange={handlePromptSelect}
                            label="Prompt Select"
                            variant="outlined"
                            style={{ width: 250 }}
                        >
                            <MenuItem value="prompt1">Standard Prompt 1</MenuItem>
                            <MenuItem value="prompt2">Standard Prompt 2</MenuItem>
                            <MenuItem value="custom">Custom Prompt</MenuItem>
                        </TextField>
                        <form>
                            {inputFields.map((lexInputField) => (
                                <div key={lexInputField.id} style={{ marginBottom: 10 }}>
                                    <FormControl style={{ marginTop: 15 }}>
                                        <TextField
                                            name="field"
                                            label="Field Name*"
                                            variant="outlined"
                                            value={lexInputField.field}
                                            onChange={(event) =>
                                                handleChangeLexInput(lexInputField.id, event)
                                            }
                                        />
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    <FormControl style={{ marginLeft: 30, marginTop: 15 }}>
                                        <TextField
                                            name="description"
                                            label="Field Desciption"
                                            variant="outlined"
                                            value={lexInputField.description}
                                            onChange={(event) =>
                                                handleChangeLexInput(lexInputField.id, event)
                                            }
                                        />
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    <FormControl style={{ marginLeft: 30, marginTop: 15 }}>
                                        <div>
                                            <Checkbox
                                                name="hallucinationCheck"
                                                label="hallucinationCheck"
                                                variant="outlined"
                                                value={lexInputField.hallucinationCheck}
                                                checked={lexInputField.hallucinationCheck}
                                                onChange={(event) =>
                                                    handleHallucinationCheck(lexInputField.id, event)
                                                }
                                            />
                                            <span>Hallucination Check</span>
                                        </div>
                                    </FormControl>
                                    <span>&nbsp;</span>
                                    <IconButton
                                        disabled={inputFields.length === 1}
                                        onClick={() => handleRemoveFields(lexInputField.id)}
                                    >
                                        <Remove />
                                    </IconButton>
                                    <IconButton onClick={handleAddFields}>
                                        <Add />
                                    </IconButton>
                                </div>
                            ))}
                        </form>
                        <br></br>
                        {promptSelect === "custom" ? (<FormControl fullWidth style={{ marginTop: 15 }}>
                            <TextField
                                name="customPrompt"
                                label="Custom Prompt"
                                variant="outlined"
                                value={prompt}
                                multiline
                                onChange={(event) =>
                                    handleChangeLexPrompt(event)
                                }
                            />
                        </FormControl>) : (<code>{prompt}</code>)}
                    </Container>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleClose}>Cancel</HVButton>
                    <HVButton variant="secondary" onClick={handleBack}>Back</HVButton>
                    <HVButton variant="primary" onClick={createProject} disabled={creating} icon={creating ? <Spinner size={14} color="#fff" /> : null}>
                        {creating ? 'Creating…' : 'Create'}
                    </HVButton>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openNewTagDialog}
                onClose={() => setOpenNewTagDialog(false)}
                aria-labelledby="create-group-projects"
                fullWidth={true}
                maxWidth='md'
            >
                <DialogTitle id="add-projects" style={{ position: 'relative', paddingRight: 48 }}>
                    Tag projects
                    <IconButton onClick={() => setOpenNewTagDialog(false)} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                {/* Quick tag suggestions */}
                <div style={{ padding: '4px 24px 12px', borderBottom: '1px solid #f0f0f0' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: '#6b6b6b', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 10 }}>Quick tags</div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {['Production', 'Testing', 'In Review'].map(preset => {
                            const active = newTagName === preset;
                            const tp = TAG_PALETTE[preset];
                            return (
                                <button key={preset} onClick={() => setNewTagName(preset)} style={{
                                    background: active ? tp.bg : '#fff',
                                    color: active ? tp.fg : HV_THEME.ink,
                                    border: `1px solid ${active ? tp.bd : '#e0e0e0'}`,
                                    borderRadius: 99, padding: '6px 16px', fontSize: 12, fontWeight: 600,
                                    cursor: 'pointer', fontFamily: 'inherit',
                                    boxShadow: active ? `inset 0 0 0 1px ${tp.bd}` : 'none'
                                }}>{preset}</button>
                            );
                        })}
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'start',
                    marginLeft: 25,
                    marginTop: 8,
                }}>
                    <Button aria-controls="simple-menu" aria-haspopup="true" onClick={(event) => setAnchorEl(event.currentTarget)}>
                        Select existing tag
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={(event) => setAnchorEl(null)}
                    >
                        {Object.keys(tags).filter((tag) => tag !== "Untagged").map((tag) => (
                            <MenuItem
                                onClick={() => {
                                    setNewTagName(tag);
                                    setAnchorEl(null);
                                }}
                            >
                                {tag}
                            </MenuItem>
                        ))}
                    </Menu>
                    <TextField
                        required
                        margin="normal"
                        id="tag"
                        label="Enter a new Tag"
                        type="text"
                        variant="outlined"
                        value={newTagName}
                        onChange={(e) => setNewTagName(e.target.value)}
                        style={{ marginLeft: 25, marginRight: 25 }}
                    />
                    {
                        newTagName && !Object.keys(tags).includes(newTagName) ? "(New Tag)" : ""
                    }
                </div>
                <TextField
                    label="Search"
                    variant="outlined"
                    value={search}
                    style={{ marginLeft: 25, marginRight: 25 }}
                    onChange={e => setSearch(e.target.value)}
                />
                <div style={{ marginLeft: 25, marginTop: 20 }}>
                    {selectedProjectsForTagging.map((project, index) => (
                        <Chip key={index} label={project} title={project} style={{ marginRight: 10, marginTop: 10 }} />
                    ))}
                </div>
                <DialogContent>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            {filteredProjects.length === 0
                                ? "No Projects Found"
                                : filteredProjects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((project, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            <Typography>
                                                {project.name}
                                            </Typography>
                                            <Typography className={classes.pos} color="textSecondary">
                                                Id: {project._id}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Checkbox
                                                checked={selectedProjectsForTagging.includes(project._id)}
                                                onChange={(e) => handleProjectSelectForTagging(e, project._id)}
                                                inputProps={{ "aria-label": "primary checkbox" }}
                                                required
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        count={filteredProjects.length}
                        page={page}
                        onChangePage={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpenNewTagDialog(false) }} variant="contained" color="secondary">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            addTagToProjects(selectedProjectsForTagging, newTagName);
                            setOpenNewTagDialog(false);
                            setNewTagName("");
                            setSelectedProjectsForTagging([]);
                            setSearch("");
                        }}
                        className="btn btn-primary"
                    >Add</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ProjectHome
